module.exports =
  auth:
    authorize: '/authServer/auth/authorize'
    permissions: '/authServer/auth/permissions'
  role:
    base: '/authServer/role/'
    detail: '/authServer/role/:roleId/detail'
    byIdentifier: '/authServer/role/byIdentifier/:roleIdentifier'
    bulk: '/authServer/role/byIdentifier/bulk'
    grant: '/authServer/role/grant/:roleId/:permissionIdentifier/:accessibility'
    revoke: '/authServer/role/grant/:roleId/:permissionIdentifier/:accessibility'
  health:
    base: '/authServer/__health'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/authServer.coffee